import { render, staticRenderFns } from "./CommunityOverviewCard.vue?vue&type=template&id=59687448"
import script from "./CommunityOverviewCard.vue?vue&type=script&lang=js"
export * from "./CommunityOverviewCard.vue?vue&type=script&lang=js"
import style0 from "./CommunityOverviewCard.vue?vue&type=style&index=0&id=59687448&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports